import { AccountBalance, AlternateEmail, LogoutOutlined, Person, QrCodeScanner, Telegram } from '@mui/icons-material'
import React, { useContext } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { LoginContext } from "../LoginContext/LoginContext"
import "./MainPageNav.css"

function MainPageNav() {
  const { dispatch } = useContext(LoginContext)
  const navigate = useNavigate()

  return (
    <div className='MainPageNav'>

    <Link to="/allmytracks">
        <div className='MainPageNav_lists'>
          <AlternateEmail className='icon_nav'/>
          <p>Balance</p>
        </div>
    </Link>
      <div className='MainPageNav_lists'>
        <b>Krypto</b>
      </div>

      <div className='MainPageNav_lists'
        onClick={()=>{
          alert("This feature coming soon")
        }}
      >
        <QrCodeScanner className='icon_nav'/>
        <p>Qrcode Login</p>
      </div>

    <a href='https://t.me/xcrxwadda'>
      <div className='MainPageNav_lists'>
        <Telegram className='icon_nav'/>
        <p>Developer</p>
      </div>
    </a>
      <div className='MainPageNav_lists'
        onClick={
          ()=>{
          dispatch({type: "LOGOUT"})
          navigate("/notuser")
        }

        }
      >
        <LogoutOutlined className='icon_nav'/>
        <p>Logout</p>
      </div>
      
    </div>
  )
}

export default MainPageNav
